import type { ReactNode } from 'react';

export function SlideFrame({ pageNum, title, banner, children, isCover, titleOffsetPx = 0 }: {
  pageNum: number;
  title?: string;
  banner?: string;
  children: ReactNode;
  isCover?: boolean;
  titleOffsetPx?: number;
}) {
  return (
    <section
      className="slide relative bg-[#121722] text-white aspect-[16/9] w-full max-w-[1280px] mx-auto mb-6 print:mb-0 print:max-w-none print:w-full overflow-hidden"
      style={{ pageBreakAfter: 'always', breakAfter: 'page' }}
    >
      {!isCover && (
        <div className="absolute top-[-14px] left-0 right-0 flex items-center pl-2 pr-6">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/triumph-logo.png" alt="Triumph Asset Management" className="h-[138px] w-auto flex-shrink-0 z-10 ml-[-19px]" />
          <h2 className="absolute left-1/2 text-[33px] font-bold tracking-wide text-white whitespace-nowrap" style={{ transform: `translateX(calc(-50% + ${16 + titleOffsetPx}px))` }}>
            {title}
          </h2>
        </div>
      )}
      <div className="absolute top-[112px] left-0 right-0 h-px bg-[#c9a84c]/80" />
      <div className="absolute bottom-[68px] left-0 right-0 h-px bg-[#c9a84c]/80" />
      {banner && (
        <div className="absolute bottom-[26px] left-0 right-0 text-center px-6">
          <span className="text-[#c9a84c] italic text-[20px] font-semibold">{banner}</span>
        </div>
      )}
      <div className="absolute bottom-[6px] left-6 right-6 flex justify-between text-[7px] text-white/50">
        <span>Triumph Asset Management  |  Confidential</span>
        <span className="tabular-nums">{pageNum}</span>
      </div>
      <div className="absolute top-[157px] bottom-[80px] left-0 right-0 px-10">
        {children}
      </div>
    </section>
  );
}
